import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m12.384 5.727.607-.6a.67.67 0 0 0-.947-.947l-.6.607a5.33 5.33 0 0 0-6.526 0l-.607-.614a.672.672 0 0 0-.947.954l.614.606A5.28 5.28 0 0 0 2.85 9a5.334 5.334 0 1 0 9.533-3.273M8.184 13a4 4 0 1 1 0-7.999 4 4 0 0 1 0 7.999M6.851 3h2.667a.667.667 0 0 0 0-1.333H6.85a.667.667 0 1 0 0 1.333m2 4a.667.667 0 0 0-1.333 0v1.26a1 1 0 1 0 1.333 0z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })